import { Button } from '@mui/material';

type ValidateButtonProps = {
    onClick: () => void;
    disabled: boolean;
    searchText: string | JSX.Element;
    dataTestId: string;
    sx?: object;
};

const ValidateButton = ({ onClick, disabled, searchText, dataTestId, sx }: ValidateButtonProps) => {
    const defaultSx = {
        color: 'white',
        px: 3,
        height: '100%',
        borderRadius: 0,
    };

    return (
        <Button
            data-testid={`${dataTestId}-button`}
            onClick={onClick}
            sx={{ ...defaultSx, ...sx }}
            disabled={disabled}
        >
            {searchText || 'Search'}
        </Button>
    );
};

export default ValidateButton;
